module.exports = __webpack_public_path__ + "static/media/www.maxine.fi.284deca7.png";